import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, map, tap } from 'rxjs';
import { IParams } from '../../model/http';


export const initItemsParams: IParams = {
  sort: '',
  order: '',
  search: '',
  take: 25,
  page: 1,
};

export interface IItemsApiResponse {
  items?: any[];
  total?: number;
  size?: number;
  page?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  private readonly itemsSubject$ = new BehaviorSubject<any>({});
  public readonly items$ = this.itemsSubject$.asObservable();

  public readonly isLoader$ = new BehaviorSubject<boolean>(false);

  public queryItemsParams = { ...initItemsParams };

  constructor(
    private readonly http: HttpClient,
    private readonly router: Router,
  ) { }

  getAll(paramsDefault: any, entity_uuid: string, entity_type: string) {
    const params = {
      ...paramsDefault,
      entity_uuid,
      entity_type,
    };
    return this.http.get<any>(environment.baseURL + '/activities/current', { params })
      .pipe(map(v => v.data));
  }

  loadItems(entity_uuid: string, entity_type: string) {
    this.isLoader$.next(true);
    return this.getAll(this.queryItemsParams, entity_uuid, entity_type)
      .pipe(tap((items) => {
        this.itemsSubject$.next(items);
        this.isLoader$.next(false);
      }));
  }

  setQueryItemsParams(params: IParams, { entity_uuid, entity_type }: any) {
    const { sort, order, search, take, page,  } = params;
    this.queryItemsParams = {
      sort: sort || typeof (sort) === 'string' ? sort : this.queryItemsParams.sort,
      order: order || typeof (order) === 'string' ? order : this.queryItemsParams.order,
      search: search || typeof (search) === 'string' ? search : this.queryItemsParams.search,
      take: take || this.queryItemsParams.take,
      page: page || this.queryItemsParams.page,
    };
    return this.loadItems(entity_uuid, entity_type);
  }

  delete(id: string) {
    return this.http.delete(environment.baseURL + `/contact/${id}`);
  }

  // getActivities(entity_uuid: string, entity_type: string) {
  //   const params = {
  //     entity_uuid,
  //     entity_type,
  //   }
  //   const url = `${environment.baseURL}/activities/current`
  //   return this.http.get<any>(url, { params })
  //     .pipe(map(v => v.data));
  // }
}
